enum Action {
  ADD_BREAK = 'addBreak',
  DELETE_BREAK = 'deleteBreak',
  UPDATE_BREAK = 'updateBreak',
  SET_BREAKS = 'setBreaks',
}

export default Action;
